import React from 'react';

export const readmore = {
  useModal: {
    modal: true,
  },
  doNotUseModal: {
    modal: false,
  },
};

export const ReadMoreContext = React.createContext(readmore.useModal);
